import {TypographyProps} from '@mui/material'
import {Typography} from './Typography'

export const Header = ({...props}: Omit<TypographyProps, 'variant'>) => {
    return <Typography variant="header" {...props}/>
}